// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3h1nB","field":"styles_field__2bojo","fieldCol":"styles_fieldCol__2e_GX","diffCol":"styles_diffCol__1ql-2","diff":"styles_diff__2iH30"};